<template>
    <div>
        <label><b>Stato</b></label>
        <div>
            <table>
                <tr>
                    <td :style="'width: 50%;'">
                        <select class="form-control" v-model="field_state.state_id" :name="name" autocomplete="on" :required="required">
                            <option v-for="record in list" :value=record.id>{{record.name}}</option>
                        </select>
                    </td>
                    <td :style="'width: 50%;'">
                        <div :style="'width:30px; height: 30px; background-color:' + field_state.color"></div>
                    </td>
                </tr>
            </table>

        </div>
    </div>
</template>
<script>
    export default {
        props:{
            state:{type:Object, required:true},
            name:{required:true},
        },
        data(){
            let field_state         = this.state;
            let list                = [];
            let required            = true;

            return {
                field_state,
                list,
                error:null,
                message:null,
                loading:false,
                validForm:false,
                required,
            };
        },
        mounted: function () {
            this.list = [];
            this.loadListStates();
        },
        methods: {
            addFiles() {
                this.error = null;
            },
            loadListStates() {
                this.errors = null;
                this.loading = true;
                axios.post('/states/all')
                .then((response) => {
                    if(response.data.result === "ok") {
                        this.list = response.data.list;
                    }
                })
                .catch((error) => {
                    this.errors = error;
                })
                .finally(() => {
                    this.loading = false
                });
            },
            getColorRGB(state_id) {
                let rgb = "";
                for(let i = 0; i < this.list.length; i++) {
                    if(this.list[i].id == state_id) {
                        rgb = this.list[i].color;
                        break;
                    }
                }
                return rgb;
            }
        },
        watch: {
            'field_state.state_id': function() {
                this.field_state.color = this.getColorRGB(this.field_state.state_id);
            }
        }
    }
</script>
